import clsx from 'clsx';
import React from 'react';

type FieldWrapperProps = {
  children: React.ReactNode;
  className?: string;
  label?: React.ReactNode;
  labelPosition?: 'top' | 'left' | 'right';
  appearance?: 'default' | 'design-system';
};

const FormLabel = ({
  children,
  className,
  htmlFor,
}: {
  children: React.ReactNode;
  className?: string;
  htmlFor?: string;
}) => (
  <label
    htmlFor={htmlFor}
    className={clsx(
      'text-sm font-medium text-rw-neutral-darker-gray',
      className
    )}
  >
    {children}
  </label>
);

export const FieldWrapper = ({
  label,
  className,
  children,
  labelPosition = 'top',
  appearance = 'default',
}: FieldWrapperProps) => {
  if (!label) {
    return <div className={className}>{children}</div>;
  }

  // Top Label
  if (labelPosition === 'top') {
    if (appearance === 'design-system') {
      return (
        <label className={clsx('group relative mt-2 block', className)}>
          <span className="absolute -top-2 left-2.5 z-10 bg-white px-0.5 text-rw-fine font-semibold text-rw-neutral-gray transition-colors group-focus-within:text-primary-teal">
            {label}
          </span>
          {children}
        </label>
      );
    }

    return (
      <FormLabel className={clsx('block', className)}>
        {label}
        <div className="mt-1">{children}</div>
      </FormLabel>
    );
  }

  return (
    <FormLabel className={clsx('flex items-center justify-between', className)}>
      {/* Left Label */}
      {labelPosition === 'left' && <span className="mr-3 flex-1">{label}</span>}

      {children}

      {/* Right Label */}
      {labelPosition === 'right' && (
        <span className="ml-3 flex-1">{label}</span>
      )}
    </FormLabel>
  );
};
